import {
  CREATE_STATE,
  DELETE_STATE,
  GET_STATES_STRUCTURE,
  GET_STATES,
  STATE_REQUEST_FAILURE,
  STATE_REQUEST,
  UPDATE_STATE
} from '../types';

const initialState = {
  states: []
};

const stateReducer = (state = initialState, action) => {
  switch (action.type) {
    case STATE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_STATES:
      return {
        ...state,
        states: action.payload,
      };
    case GET_STATES_STRUCTURE: {
      return {
        ...state,
        stateStructure: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_STATE:
      return {
        ...state,
        states: [action.payload, ...state.states],
        loading: false,
        error: null
      };
    case UPDATE_STATE:
      const statesData = state.states.slice(0);
      const uIndex = statesData.findIndex((data) => data.id === action.payload.id);
      statesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        states: [ ...statesData ],
        loading: false,
        error: null
      };
    case DELETE_STATE:
      const states = state.states?.slice(0);
      const index = states.findIndex((data) => data.id === action.id);
      if (index > -1) {
        states.splice(index, 1);
      }
      return {
        ...state,
        states: [...states],
        loading: false,
        error: null
      }
    case STATE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default stateReducer;
